// extracted by mini-css-extract-plugin
export var drawerPaper = "_20-0";
export var itemCard = "_20-1";
export var itemImage = "_20-2";